<template>
    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          sm="6">
          <v-text-field
            v-model="searchCriteria.flightNumber"
            prepend-icon="mdi-airplane"
            label="Flight number"
            dense>
          </v-text-field>
          <v-btn
            class="ma-2 primary"
            @click="searchFlights">Search
            <v-icon class="ml-2">mdi-account-search</v-icon>
          </v-btn>
          <v-btn
            class="ma-2 secondary"
            @click="clearSearch">Clear
            <v-icon class="ml-2">mdi-eraser</v-icon>
          </v-btn>
        </v-col>
        </v-row>
        <v-row>
          <v-data-table
            :items-per-page=25
            :headers="headers"
            :items="ADMIN_FLIGHTS.flights"
            dense>
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Flights</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical>
                </v-divider>
                <v-spacer></v-spacer>
                <v-btn depressed color="primary" @click="addFlight()">Add</v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.isDomestic="{ item }">
              <v-simple-checkbox
                v-model="item.isDomestic"
                disabled>
              </v-simple-checkbox>
            </template>
            <template v-slot:item.isDeparting="{ item }">
              <v-simple-checkbox
                v-model="item.isDeparting"
                disabled>
              </v-simple-checkbox>
            </template>
            <template v-slot:item.isActive="{ item }">
              <v-simple-checkbox
                v-model="item.isActive"
                disabled>
              </v-simple-checkbox>
            </template>
            <template v-slot:item.flightTime="{ item }">
              {{ $moment(item.flightTime, "HH:mm:ss").format(DISPLAY_TIME_FORMAT) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                dense
                small
                class="mr-2"
                title="Edit flight"
                @click="editFlight(item)">mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-row>
        <v-dialog v-model="dialogEdit" max-width="500px">
          <v-card>
            <v-alert
              v-if="SHOW_ALERT"
              prominent
              type="error">
              <v-row align="center">
                <v-col class="grow">{{ ALERT_TEXT }}</v-col>
                <v-col class="shrink">
                  <v-btn @click="closeAlert()">Ok</v-btn>
                </v-col>
              </v-row>
            </v-alert>
            <v-card-title>
              Edit Flight
            </v-card-title>
            <v-card-text>
              <ValidationObserver ref="flight" v-slot="{ invalid, valid, errors }">
                <v-form v-model="isValid">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-container>
                        <v-row dense>
                          <v-col>
                            <ValidationProvider
                              rules="required"
                              name="FlightNumber"
                              vid="flightNumber"
                              v-slot="{ errors }">
                              <v-text-field
                                v-model="editedItem.flightNumber"
                                :error-messages="errors"
                                maxlength="50"
                                label="Flight number"
                                append-icon="mdi-airplane"
                                placeholder="Enter flight number"
                                dense>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <ValidationProvider
                              rules="required"
                              name="FlightTime"
                              vid="flightTime"
                              v-slot="{ errors }">
                              <v-text-field
                                label="Flight time"
                                value="12:30:00"
                                type="time"
                                v-model="editedItem.flightTime"
                                suffix="AEST">
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <ValidationProvider
                              rules="required"
                              name="Carrier"
                              vid="carrier"
                              v-slot="{ errors }">
                            <v-autocomplete
                              v-model="editedItem.carrierId"
                              :items="ADMIN_FLIGHTS.carriers"
                              hint="Select the carrier"
                              persistent-hint
                              item-text="name"
                              item-value="id"
                              cache-items
                              flat
                              clearable
                              :error-messages="errors"
                              label="Carrier">
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-row>
                        <v-row dense>
                          <v-col>
                            <v-checkbox
                              label="Is Domestic"
                              v-model="editedItem.isDomestic"
                              dense />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col>
                            <v-checkbox
                              label="Is Active"
                              v-model="editedItem.isActive"
                              dense />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col>
                            <v-checkbox
                              label="Is Departing"
                              v-model="editedItem.isDeparting"
                              dense />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <ValidationProvider
                              rules="required"
                              name="OtherAirport"
                              vid="otherAirport"
                              v-slot="{ errors }">
                              <v-text-field
                                v-model="editedItem.otherAirport"
                                :error-messages="errors"
                                label="Other Airport"
                                append-icon="mdi-airport"
                                placeholder="Enter other airport">
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <ValidationProvider
                              rules="required"
                              name="Terminal"
                              vid="terminal"
                              v-slot="{ errors }">
                              <v-text-field
                                v-model="editedItem.terminal"
                                :error-messages="errors"
                                label="Terminal"
                                append-icon="mdi-sign-direction"
                                placeholder="Enter terminal">
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                  </v-menu>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
/* eslint-disable camelcase */
import {
  required,
} from 'vee-validate/dist/rules';
/* eslint-enable camelcase */
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';
import storeConstants from '@/store/storeConstants';

extend('required', required);

export default {
  name: 'Flights',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
  },
  data: () => ({
    searchCriteria: {
      flightNumber: null,
    },
    defaultItem: {
      flightNumber: undefined,
      carrierId: undefined,
      isDomestic: false,
      isDeparting: false,
      isActive: true,
      flightTime: undefined,
      otherAirport: undefined,
      terminal: undefined,
    },
    editedItem: {},
    dialogEdit: false,
    menu1: false,
    isValid: false,
    headers: [
      { text: 'Actions', value: 'actions', sortable: false },
      { text: 'FlightNumber', value: 'flightNumber', filterable: true },
      { text: 'Carrier', value: 'carrierName' },
      { text: 'Is Domestic', value: 'isDomestic' },
      { text: 'Flight Time', value: 'flightTime' },
      { text: 'Is Departing', value: 'isDeparting' },
      { text: 'Other Airport', value: 'otherAirport' },
      { text: 'Active', value: 'isActive' },
    ],
  }),
  methods: {
    ...mapActions([
      storeConstants.SET_ALERT_DETAILS,
      storeConstants.GET_ADMIN_FLIGHTS,
      storeConstants.SAVE_ADMIN_FLIGHT,
      storeConstants.SET_ADMIN_FLIGHTS]),
    searchFlights() {
      this.$store.commit('SET_LOADING_TEXT', 'Searching flights...');
      this.$store.commit('SET_LOADING', true);

      this.GET_ADMIN_FLIGHTS(this.searchCriteria)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.$store.commit('SET_LOADING', false);
        })
        .catch(() => {
          this.$store.commit('SET_LOADING', false);
        });
    },
    clearSearch() {
      this.$store.commit(storeConstants.SET_ADMIN_FLIGHTS, []);
      this.searchCriteria = {};
    },
    editFlight(flight) {
      this.editedItem = Object.assign({}, flight);
      this.dialogEdit = true;
    },
    addFlight() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialogEdit = true;
    },
    save() {
      this.$refs.flight.validate().then((success) => {
        this.isValid = success;
        if (this.isValid) {
          this.SAVE_ADMIN_FLIGHT(this.editedItem)
            .then(() => {
              this.dialogEdit = false;
              this.clearEditItem();
              this.searchFlights();
            },
            (error) => {
              this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        }
      });
    },
    clearEditItem() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.dialogEdit = false;
      });
    },
    close() {
      this.SET_ALERT_DETAILS({ alertText: undefined, showAlert: false });
      this.dialogEdit = false;
      this.searchFlights();
    },
    closeAlert() {
      this.SET_ALERT_DETAILS({ alertText: undefined, showAlert: false });
    },
  },
  computed: {
    ...mapGetters([
      storeConstants.DISPLAY_TIME_FORMAT,
      storeConstants.ADMIN_FLIGHTS,
      storeConstants.SHOW_ALERT,
      storeConstants.ALERT_TEXT]),
  },
};
</script>
